<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <StartClaimTable title="Start Claim"></StartClaimTable>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StartClaimTable from "./Tables/StartClaimTable";
export default {
  name: "StartClaim",
  components: {
    StartClaimTable,
  },
};
</script>
<style></style>
